import ErrorStore from './error-store.vue'
export default ErrorStore



// WEBPACK FOOTER //
// ./src/components/main/components/error-store/index.js